import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "../Css/SucessStory.css";
import { Card, Container } from "react-bootstrap";
import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa";
import ClintICon from "../aseets/img/clintICon.png";
import axios from "axios";

const SucessStory = () => {
  const [story, setStory] = useState([]);
  const getTestimonialData = async () => {
    try {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/api/auth/listActive/Testimonials`
        )
        .then((res) => {
          setStory(res.data.slice(0,4));
        });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getTestimonialData();
  }, []);

  // const story = [
  //   {
  //     title: "-Aarav, 32, Corporate Lawyer",
  //     subtitle: "USA",
  //     description:
  //       "Platinum Matches exceeded my expectations. Their personalized matchmaking and coaching truly helped me find someone I deeply connect with."
  //   },
  //   {
  //     title: "-Rahul, 30, Software Engineer",
  //     subtitle: "Canada",
  //     description:
  //      "I never thought finding someone so compatible would be this smooth. Platinum Matches’ blend of tradition and innovation truly works wonders."
  //   },
  //   {
  //     title: "-Diya, 28, Marketing Manager",
  //     subtitle: "UAE",
  //     description:
  //       "Their expertise in understanding my needs was incredible. I found my partner within months, and we’re so happy together!"
  //   },
  //   {
  //     title: "-Neha, 32, Financial Analyst",
  //     subtitle: "India",
  //     description:
  //      "The personalized coaching sessions helped me understand what I was truly looking for in a partner. Forever grateful to Platinum Matches!"
  //   },

  // ];

  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 3000,
    autoplaySpeed: 500,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024, // Tablets and small desktops
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768, // Mobile landscape
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480, // Mobile portrait
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <React.Fragment>
      <div className="suceesStoryDiv">
        <Container>
          <div className="sucessTitle">Our Success Stories</div>
          <div className="sucessSubTtile">from happy, delighted couples</div>
          <Slider {...settings}>
            {/* {stories.map((story, index) => (
              <div className="mainDivSucessStory" key={index}>
                <div className="sucessTitle">{story.title}</div>
                <div className="sucessSubTtile">{story.subtitle}</div>
                <div className="sucessDescription">
                  <div className="quoteIcon">
                    <FaQuoteLeft />
                  </div>
                  <div className="suceessDescriptionDiv">
                    {story.description}
                    <div className="subDiscription">{story.subDescription}</div>
                    <div className="clintIconDiv">
                      <img className="clintIcon" src={`${process.env.REACT_APP_API_URL}/${story.clientIcon}`} alt="icon" />
                    </div>
                    <div className="iconTitle">{story.clientName}</div>
                  </div>
                  <div className="quoteIcon">
                    <FaQuoteRight />
                  </div>
                </div>
              </div>
            ))} */}
            {story?.map((data) => (
              <div className="suceessDiv">
                <Card className="storyCard">
                  <div className="suceessDescriptionDiv">
                    {data.description.length > 150
                      ? `${data.description.slice(0, 150)}...`
                      : data.description}{" "}
                  </div>
                  <div className="authTitle">
                    - {data.clientName}, {data.age}, {data.profession}.
                  </div>
                  <div className="authSubTitle">{data.country}</div>
                </Card>
              </div>
            ))}
          </Slider>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SucessStory;
